/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 09:52:22 
 * @Last Modified by:   jingyu.yang 
 * @Last Modified time: 2021-12-17 09:52:22 
 */
import { post } from '../cvacRequest/http';
/**
 * 查询商品列表
 * @param {*} p
 * @returns
 */
export const getGoodslist = (p) => post('/goods/live/search', p);
/**
 * 上架商品
 * @param {*} p
 * @returns
 */
export const onshelfGoods = (p) => post('/goods/live/onshelf', p);
/**
 * 下架商品
 * @param {*} p
 * @returns
 */
export const offshelfGoods = (p) => post('/goods/live/offshelf', p);
/**
 * 推送商品
 * @param {*} p
 * @returns
 */
export const pushGoods = (p) => post('/goods/push', p);
/**
 * 获取推送商品
 * @param {*} p
 * @returns
 */
export const getPushGoods = (p) => post('/goods/pushgoodsid', p);
